import React, { SetStateAction } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
} from '@material-ui/core';
import { ExpandMore, Add } from '@material-ui/icons';
import { useStyles } from './styles';
import { generateId } from '../../pages/AddEducation/utils';
import EquipeMissaoForm from './EquipeMissaoForm';
import { EquipeMissaoObject } from '../../@types/educationTypes';

const initialMateriaisUtilizadosDetails: EquipeMissaoObject = {
  index: 0,
  cargo: 'Agente',
  funcao: 'Apoio Operacional',
  nome: '',
  _localId: '',
};

interface IProps {
  equipeMissaoDetails: EquipeMissaoObject[];
  setEquipeMissaoDetails: React.Dispatch<SetStateAction<EquipeMissaoObject[]>>;
  requiredFields: string[];
}

const EquipeMissaoFormGroup: React.FC<IProps> = ({
  equipeMissaoDetails,
  setEquipeMissaoDetails,
  requiredFields,
}) => {
  const classes = useStyles();

  const addNewEquipeMissaoDetails = () => {
    const list = [...equipeMissaoDetails];
    list.push({
      ...initialMateriaisUtilizadosDetails,
      index: equipeMissaoDetails.length,
      _localId: generateId(),
    });
    setEquipeMissaoDetails(list);
  };

  const deleteEquipeMissaoDetails = (index: number) => {
    const list = [...equipeMissaoDetails]
      .filter((item) => {
        return item.index !== index;
      })
      .map((item, i) => {
        return { ...item, index: i };
      });
    setEquipeMissaoDetails([...list]);
  };

  const changeEquipeMissaoDetailState = (via: EquipeMissaoObject) => {
    const list = [...equipeMissaoDetails];
    list[via.index] = via;
    setEquipeMissaoDetails(list);
  };

  return (
    <Accordion className={classes.accordionContainer}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Equipe da Missão</Typography>{' '}
      </AccordionSummary>
      <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>
        <div>
          <div className={classes.addButtonContainer}>
            <Button
              color="default"
              variant="outlined"
              endIcon={<Add />}
              className={classes.addButton}
              onClick={() => addNewEquipeMissaoDetails()}
            >
              Adicionar
            </Button>
          </div>

          {equipeMissaoDetails.map((item) => {
            return (
              <EquipeMissaoForm
                key={item._localId}
                equipeMissaoDetailsObject={item}
                deleteEquipeMissaoDetails={deleteEquipeMissaoDetails}
                changeEquipeMissaoDetailState={changeEquipeMissaoDetailState}
                requiredFields={requiredFields}
              />
            );
          })}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default EquipeMissaoFormGroup;
